module.exports = __webpack_public_path__ + "static/new-logo-white-0d8f318004808e1dc5d0b1e2b8309b4a.png";